import { styler, spring, tween, easing } from 'popmotion'

export const new_ = {
    enter: (el, done, direction) => {
        const e = styler(el)
        const img = styler(el.querySelector('video'))
        //const playBtn = styler(el.querySelector('.sliderVideoInfo__playBtnImg'))
        const playBtn = styler(el.querySelector('.sliderVideoInfo__playBtnWrapper'))
        const editor = styler(el.querySelector('.sliderVideoInfo__editorNameWrapper'))
        const client = styler(el.querySelector('.sliderVideoInfo__clientNameWrapper'))
        const title = styler(el.querySelector('.sliderVideoInfo__videoNameWrapper'))

        el.querySelector('video').play()

        // entire el
        tween({
            from: { opacity: 0 },
            to: { opacity: 1 },
            duration: 400
        }).start(e.set)

        spring({
            //from: { x: direction === 'next' ? '40%' : '-40%' },
            from: { x: direction === 'next' ? '200px' : '-200px' },
            to: { x: '0%'/*, opacity: 1*/ },
            damping: 15,
            stiffness: 55,
            ease: easing.easeOut,
        }).start(playBtn.set)

        // editor
        tween({
            //from: { x: direction === 'next' ? '20%' : '-20%' },
            from: { x: direction === 'next' ? '400px' : '-400px' },
            //to: { x: editor.get('x')/*, opacity: 1*/ },
            to: { x: '0%' },
            //duration: 400
            duration: 600,
            ease: easing.easeOut,
        }).start(editor.set)

        // client
        tween({
            //from: { x: direction === 'next' ? '40%' : '-40%' },
            from: { x: direction === 'next' ? '600px' : '-600px' },
            //to: { x: client.get('x'), opacity: 1 },
            to: { x: '0%' },
            //duration: 400
            duration: 600,
            ease: easing.easeOut,
        }).start(client.set)

        // title
        tween({
            //from: { x: direction === 'next' ? '60%' : '-60%'},
            from: { x: direction === 'next' ? '800px' : '-800px'},
            //to: { x: title.get('x'), opacity: 1 },
            to: { x: '0%' },
            //duration: 400
            duration: 600,
            ease: easing.easeOut,
            }).start(title.set)

        // main image
        spring({
            from: { x: direction === 'next' ? '100%' : '-100%' },
            to: { x: '0%', scale: 1 },
            damping: 25,
            stiffness: 55,
            //duration: 10000,
        }).start({
            update: img.set,
            complete: done
        })
    },
    leave: (el, done, direction) => {
        //done()
        //return
        //debugger
        const img = styler(el.querySelector('video'))
        const playBtn = styler(el.querySelector('.sliderVideoInfo__playBtnWrapper'))
        const editor = styler(el.querySelector('.sliderVideoInfo__editorNameWrapper'))
        const client = styler(el.querySelector('.sliderVideoInfo__clientNameWrapper'))
        const title = styler(el.querySelector('.sliderVideoInfo__videoNameWrapper'))

        /*
        // meta
        spring({
            to: { x: direction === 'next' ? '-10%' : '10%', opacity: 0 },
            from: { x: meta.get('x'), opacity: 1 },
            duration: 400
        }).start(meta.set)
        */

        /*// playBtn
        spring({
            to: { x: direction === 'next' ? '-10%' : '10%', opacity: 0 },
            from: { x: playBtn.get('x'), opacity: 1 },
            //duration: 400
            duration: 2400
        }).start(playBtn.set)

        // editor
        spring({
            to: { x: direction === 'next' ? '-20%' : '20%', opacity: 0 },
            from: { x: editor.get('x'), opacity: 1 },
            //duration: 400
            duration: 3400
        }).start(editor.set)

        // client
        spring({
            to: { x: direction === 'next' ? '-30%' : '30%', opacity: 0 },
            from: { x: client.get('x'), opacity: 1 },
            //duration: 400
            duration: 4400
        }).start(client.set)

        // title
        spring({
            to: { x: direction === 'next' ? '-40%' : '40%', opacity: 0 },
            from: { x: title.get('x'), opacity: 1 },
            //duration: 400
            duration: 5400
        //}).start(client.set)
        }).start({
            update: title.set,
            complete: done
        })*/

        spring({
            //from: { x: direction === 'next' ? '40%' : '-40%' },
            //to: { x: direction === 'next' ? '-2000px' : '2000px' },
            to: { x: direction === 'next' ? '-100%' : '100%', opacity: 0 },
            //to: { x: direction === 'next' ? '-100%' : '100%' },
            from: { x: client.get('x') || '0%', opacity: 1},
            damping: 15,
            stiffness: 55,
            ease: easing.easeOut,
        }).start(playBtn.set)

        // editor
        spring({
            //from: { x: direction === 'next' ? '20%' : '-20%' },
            //to: { x: direction === 'next' ? '-400px' : '400px' },
            to: { x: direction === 'next' ? '-100%' : '100%', opacity: 0 },
            from: { x: client.get('x'), opacity: 1 },
            //duration: 400
            duration: 400,
            ease: easing.easeOut,
        }).start(editor.set)

        // client
        spring({
            //from: { x: direction === 'next' ? '40%' : '-40%' },
            //to: { x: direction === 'next' ? '-600px' : '600px' },
            to: { x: direction === 'next' ? '-100%' : '100%', opacity: 0 },
            from: { x: client.get('x'), opacity: 1 },
            //duration: 400
            duration: 400,
            ease: easing.easeOut,
        }).start(client.set)

        // title
        spring({
            //from: { x: direction === 'next' ? '60%' : '-60%'},
            //to: { x: direction === 'next' ? '-800px' : '800px'},
            to: { x: direction === 'next' ? '-100%' : '100%', opacity: 0 },
            from: { x: client.get('x'), opacity: 1},
            //duration: 400
            duration: 400,
            ease: easing.easeOut,
        }).start(title.set)

        // main image
        spring({
            from: { x: img.get('x') || '0%', opacity: 1 },
            to: { x: direction === 'next' ? '-100%' : '100%', opacity: 0 },
            damping: 15,
            stiffness: 55,
            duration: 400,
        }).start({
            update: img.set,
            complete: done
        })
    }
}



/* old*/
export default {
    enter: (el, done, direction) => {
        /*done()
        return*/
        const e = styler(el)
        const img = styler(el.querySelector('video'))
        const meta = styler(el.querySelector('.sliderVideoInfoWrapper'))

        // entire el
        tween({
            from: { opacity: 0 },
            to: { opacity: 1 },
            duration: 400
        }).start(e.set)

        // meta
        spring({
            from: { x: direction === 'next' ? '40%' : '-40%', opacity: 0 },
            to: { x: '0%', opacity: 1 },
            damping: 15,
            stiffness: 55
        }).start(meta.set)

        // main image
        spring({
            from: { x: direction === 'next' ? '100%' : '-100%' },
            to: { x: '0%', scale: 1 },
            damping: 25,
            stiffness: 55
        }).start({
            update: img.set,
            complete: done
        })
    },
    leave: (el, done, direction) => {
        /*done()
        return*/
        //debugger
        const img = styler(el.querySelector('video'))
        const meta = styler(el.querySelector('.sliderVideoInfoWrapper'))

        // meta
        spring({
            to: { x: direction === 'next' ? '-10%' : '10%', opacity: 0 },
            from: { x: meta.get('x'), opacity: 1 },
            duration: 400
        }).start(meta.set)

        // main image
        spring({
            from: { x: img.get('x') || '0%', opacity: 1 },
            to: { x: direction === 'next' ? '-100%' : '100%', opacity: 0 },
            damping: 15,
            stiffness: 55
        }).start({
            update: img.set,
            complete: done
        })
    },
    enter_wo_slide: (el, done, direction) => {
        const e = styler(el)
        const img = styler(el.querySelector('video'))

        // entire el
        tween({
            from: { opacity: 0 },
            to: { opacity: 1 },
            duration: 400
        }).start({
            update: e.set,
            complete: done,
        })
    },
    leave_wo_slide: (el, done, direction) => {
        const img = styler(el.querySelector('video'))

        // main image
        spring({
            from: {  opacity: 1 },
            to: { opacity: 0 },
            damping: 15,
            stiffness: 55
        }).start({
            update: img.set,
            complete: done
        })
    },
}
